<script>
import PhoneField from '@phoenix/mixins/components/form/fields/PhoneField';
import { useField } from '@phoenix/composables/field';
import { isLTRDir } from '@phoenix/helpers/text-helper';

export default {
  mixins: [PhoneField],

  setup(props) {
    return useField(props);
  },

  methods: {
    isDialCodeSeparated() {
      return isLTRDir();
    },
  },
};
</script>

<template>
  <text-field ref="fieldRef" v-model="value" :should-validate="false" />
</template>
